/* jshint esversion: 6 */
import {Assert} from "common/Assert";

function convertScormLessonStatus( lessonStatus ) {

    Assert.checkArgumentType(lessonStatus, "string" );
    Assert.checkState(lessonStatus.length > 0 );

    // 'c'ompleted, 'p'assed or else 'i'ncomplete
    const firstChar = lessonStatus.charAt(0);
    return "cp".includes(firstChar)? firstChar : "i";
}

export function buildCommitData( scormScoData ) {

    Assert.checkArgument(scormScoData);

    let aiccData,
        value;

    const aiccLessonStatus = convertScormLessonStatus( scormScoData.get("cmi.core.lesson_status") );

    aiccData = "[Core]" + "\r\n";
    aiccData += `Lesson_Status=${aiccLessonStatus}\r\n`;
    aiccData += `Score=${scormScoData.get("cmi.core.score.raw")}\r\n`;

    value = scormScoData.get("cmi.core.session_time");
    if (value !== "null") {
        aiccData += `Time=${value}\r\n`;
    }

    value = scormScoData.get("cmi.core.lesson_location");
    if (value !== "null") {
        aiccData += `Lesson_Location=${value}\r\n`;
    }

    value = scormScoData.get("cmi.suspend_data");
    if (value !== "null") {
        aiccData += "[Core_Lesson]" + "\r\n";
        aiccData += `ttkf_data=${encodeURIComponent(value)}`;
    }

    return aiccData;
}
